import { render, staticRenderFns } from "./StatusOsSetting.vue?vue&type=template&id=7ec0a4b9"
import script from "./StatusOsSetting.vue?vue&type=script&lang=js"
export * from "./StatusOsSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports